<h2 mat-dialog-title>Kontrolltermin bearbeiten</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="isLoading" class="flex justify-center items-center py-4">
    <mat-spinner diameter="30"></mat-spinner>
    <span class="ml-3 text-gray-600">Lade Daten...</span>
  </div>
  
  <div *ngIf="!isLoading" class="dialog-content space-y-4">
    <!-- Techniker Selection -->
    <div class="form-group">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="techniker_id">Techniker *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="techniker_id"
        [(ngModel)]="selectedTechnikerId"
        [disabled]="isSaving">
        <option value="">Techniker auswählen</option>
        <option *ngFor="let techniker of technikerOptions" [value]="techniker.id">
          {{ techniker.display_name }} ({{ techniker.nummer }}) - {{ techniker.funktion }}
        </option>
      </select>
      <div *ngIf="!selectedTechnikerId && !isSaving" class="text-red-500 text-sm mt-1">
        Bitte wählen Sie einen Techniker aus
      </div>
    </div>

    <!-- Prüfdatum (only if user has permission and status allows) -->
    <div class="form-group" *ngIf="canEditPruefdatum">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="pruefdatum">Prüfdatum</label>
      <input
        type="date"
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="pruefdatum"
        [(ngModel)]="pruefdatum"
        [disabled]="isSaving" />
    </div>

    <!-- Soll-Zeit -->
    <div class="form-group" *ngIf="canEditZeiten">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="soll_zeit">Soll-Zeit (Minuten)</label>
      <input
        type="number"
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="soll_zeit"
        [(ngModel)]="sollZeit"
        [disabled]="isSaving"
        min="0"
        placeholder="0" />
    </div>

    <!-- Ist-Zeit -->
    <div class="form-group" *ngIf="canEditZeiten">
      <label class="form-label text-sm font-medium text-gray-700 mb-1" for="ist_zeit">Ist-Zeit (Minuten)</label>
      <input
        type="number"
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="ist_zeit"
        [(ngModel)]="istZeit"
        [disabled]="isSaving"
        min="0"
        placeholder="0" />
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onCancel()" [disabled]="isSaving">Abbrechen</button>
  <button mat-button (click)="onSave()" [disabled]="!selectedTechnikerId || isSaving" color="primary">
    <span *ngIf="isSaving">Wird gespeichert...</span>
    <span *ngIf="!isSaving">Speichern</span>
  </button>
</mat-dialog-actions>



